import React, { useId, useRef } from 'react';
import useCamada from './useCamada';

/**
 * PainelLateral — gaveta que entra pela direita para formulário ou ficha longa.
 * Cabeçalho com título, corpo rolável e rodapé de ações. Esc e clique no véu fecham.
 */
export default function PainelLateral({ aberto, onFechar, titulo, rodape, children }) {
  const gerado = useId();
  const tituloId = `gaveta-${gerado}-titulo`;
  const caixa = useRef(null);
  useCamada(aberto, onFechar, caixa);

  if (!aberto) return null;

  return (
    <div className="sj-veu sj-veu--lateral" onMouseDown={(e) => { if (e.target === e.currentTarget) onFechar?.(); }}>
      <div ref={caixa} className="sj-gaveta" role="dialog" aria-modal="true" aria-labelledby={tituloId}>
        <header className="sj-gaveta__cabeca">
          <h2 id={tituloId} className="titulo-secao">{titulo}</h2>
        </header>
        <div className="sj-gaveta__corpo">{children}</div>
        {rodape && <footer className="sj-gaveta__rodape">{rodape}</footer>}
      </div>
    </div>
  );
}
